var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('v-alert',{staticClass:"mt-3",attrs:{"border":"left","text":"","type":"info","elevation":"0"}},[_vm._v(" "+_vm._s(_vm.$t('serviceDialog.tags.sourceDescription'))+" ")]),_c('tag-form',{attrs:{"loading":_vm.loading || _vm.$wait.is('getServiceTags'),"value":_vm.formData,"hide-create":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }